var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.096 36.2221C117.774 31.2423 113.877 27.3201 108.929 25.9888C99.961 23.5706 63.9997 23.5706 63.9997 23.5706C63.9997 23.5706 28.0385 23.5706 19.07 25.9891C14.1222 27.3203 10.2255 31.2423 8.903 36.2223C6.5 45.2486 6.5 64.0818 6.5 64.0818C6.5 64.0818 6.5 82.9153 8.903 91.9413C10.2255 96.9213 14.1222 100.68 19.07 102.012C28.0385 104.43 63.9997 104.43 63.9997 104.43C63.9997 104.43 99.961 104.43 108.929 102.011C113.877 100.68 117.774 96.9211 119.096 91.9411C121.499 82.9151 121.499 64.0816 121.499 64.0816C121.499 64.0816 121.499 45.2486 119.096 36.2221Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2383 81.1809V46.9827L82.2948 64.0822L52.2383 81.1809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0dc430ef6525b838eda94b8367e15388.svg";
export { ForwardRef as ReactComponent };